import Vue from "vue";
import axios from "axios";
import users from "../../users";
import VueRecaptcha from "vue-recaptcha";
import ldf from "@/localDataFunctions";
import otpDelayFunc from "@/otpDelayFunc";

Vue.component("vue-recaptcha", VueRecaptcha);

const portalProfileDef = {
  None: { name: "None", type: 0 },
  Employee: { name: "Employee Portal", type: 1 },
  Customer: { name: "Customer Portal", type: 2 },
};
const portalTextDef = {
  None: { name: "None", type: 0 },
  EmployeeAccountDescription: {
    name: "Employee Account Description",
    type: 40,
  },
  CustomerAccountDescription: { name: "Customer Account Description", type: 3 },
};

const actions = {
  registration: "registration",
  newCustomer: "newCustomer",
  signin: "signin",
  passwordReset: "passwordReset",
};

export default {
  errorName: "ErrorsMessages",
  name: "Login",
  mixins: [users, ldf, otpDelayFunc],
  components: {
    EmailComp: require("../../components/email.vue").default,
    NewPasswordComp: require("../../components/newPassword.vue").default,
    TermsConditionsComp: require("../../user/customer/terms.vue").default,
  },
  data: function () {
    return {
      legalLabel: "",
      loginBackgroundColor: "",
      loginFontColor: "",
      brandingAccentColor: "",
      brandingColor: "",
      showLicenceAgreementButton: false,
      showTermsDialog: false,
      actionTriggered: "",
      reCaptchaWarn: false,
      reCaptchaEnabled: false,
      reCaptchaPassed: false,
      reCaptchaApiKey: null,
      ebillEnabeled: false,
      registration: false,
      resetPassword: false,
      bShowTerms: false,
      accountName: "",
      id: "",
      mobileNo: "",
      regMessage: "",
      email: { email: "", valid: false },
      passwords: { password: "", password2: "", canContinue: false },
      otpCode: "",
      otpCodeSent: false,
      trustedComputer: false,
      acceptPrivacy: true,
      registrationCompleted: false, //TBI
      sendPasswordCompleted: false,
      messages: { error: "" },
      isInComm: false,
      bValidateCustomerAccountEmail: true,
      bValidateCustomerAccountIdNo: true,
      bValidateEmployeeAccountIdNo: true,
      bValidateCustomerAccountMobileNo: false,
      bSelectAccount: false,
      bStrongPassword: false,
      regAccDescription: "",
      regAccDescriptionTooltip: "",
      regCustomerAccountIdNoTooltip: "",
      regCustomerMobileNoTooltip: "",
      regAccIDNumber: "",
      privacyLinkUrl: "",
      settings: { welcomeMsg: "Welcome", orgShortName: "" },
      termsAgreed: false,
      showDialog: false,
      portalProfileType: portalProfileDef.Customer.type,
      oidcModel: null,
      portalAuthenticationType: 0,
      profileStatus: -1,
      accountHelpImage: "",
      loginOtp: false,
      showImageDlg: false,
      brandingLoginPrimaryColor: "",
      brandingLoginSecondaryColorText: "",
      newCustomerEvaluationApplication: false,
      newCustomerApplication: false,
      newCustomerEvalButtonText: "",
      forgotPasswordButtonText: "",
      registerAccountButtonText: "",

      licenceAgreementHash: null,
      licenceAgreementText: null,

      otpCodeConfirm: "",
      activateAccountResultErrors: [
        this.$t("login.AccActivationError"),
        this.$t("login.AccActivationInvalidOtpCode"),
        this.$t("login.AccActivationExpiredOtpCode"),
      ],
    };
  },
  computed: {
    ebillMsg: function () {
      return this.$t("login.registerEbill"); // + ': ' + window.location.hostname + '/ebill'
    },
    ebillUnsubMsg: function () {
      return this.$t("login.unsubscribeEbill"); // + ': ' + window.location.hostname + '/unsubscribe'
    },
    loginEnabled: function () {
      var value =
        this.email.valid &&
        this.passwords.password.length > 0 &&
        !this.isInComm;

      if (this.enforceLicenceAgreement && !this.acceptPrivacy) value = false;
      return value;
    },
    registerEnabled: function () {
      return (
        this.email.valid &&
        this.passwords.canContinue &&
        this.accountName.length > 0 &&
        (this.bValidateCustomerAccountIdNo === true ||
        this.bValidateEmployeeAccountIdNo === true
          ? this.id.length > 0
          : true) &&
        /*        (this.bValidateCustomerAccountMobileNo === true ? this.mobileNo.length > 0 : true) &&*/
        !this.isInComm &&
        this.termsAgreed
      );
    },
    resetPasswordEnabled: function () {
      return this.email.valid && !this.isInComm && !this.sendPasswordCompleted;
    },
    languageLocale: function () {
      return this.$i18n.locale;
    },
    enforceLicenceAgreement: function () {
      return (
        this.licenceAgreementText &&
        this.licenceAgreementText.length > 0 &&
        this.bShowTerms
      );
    },
    isEmailEntered: function () {
      return this.email.email.includes("@");
    },
  },
  watch: {
    languageLocale: function (value) {
      this.getRegisterAccountDescription();
      this.getRegisterMessage();
      this.getPortalWelcomeMessage();
    },
    timeBeginMinutes: function (value) {
      this.appData.periodBeginMin = value;
    },
    timeEndHours: function (value) {
      this.appData.periodEndHH = value;
    },
    timeEndMinutes: function (value) {
      this.appData.periodEndMin = value;
    },
    acceptPrivacy: function (value) {
      if (!value || !this.enforceLicenceAgreement) return;

      this.showTermsDialog = this.bShowTerms;
    },
    termsAgreed: function (value) {
      if (!value || !this.enforceLicenceAgreement) return;

      this.showTermsDialog = this.bShowTerms;
    },
  },
  created() {
    this.getLicenceAgreement();

    this.getButtonsText();
    this.getSettings();
    this.getTermsBox();
    this.getPortalWelcomeMessage();
    this.getRegisterIDNumber();
    this.trustedComputer = this.$localStorage.get("_trustedComputer") == "true";
    this.getPrivacyLink();
    this.getAccountExampleImage();
    this.loginFontColor =
      "color: " + this.$localStorage.get("brandingLoginPrimaryColor");
    this.loginBackgroundColor =
      "background-color: " +
      this.$localStorage.get("brandingLoginSecondaryColor");
    //this.brandingLoginPrimaryColor = 'background-color: ' + '#f55a06';
    this.brandingLoginSecondaryColorText =
      "color: " + this.$localStorage.get("brandingSecondaryColor");
    this.brandingLoginSecondaryColorBackground =
      "background-color: " + this.$localStorage.get("brandingSecondaryColor");

    this.brandingColor =
      "background-color: " + this.$localStorage.get("brandingColor");
    this.brandingAccentColor =
      "color: " + this.$localStorage.get("brandingAccentColor");

    this.getAccDescriptionTooltip();
    this.getCustomerAccountIdNoTooltip();
    this.getCustomerMobileNoTooltip();
  },
  methods: {
    onCaptchaVerified(response) {
      axios
        .get("/Utility/ValidateReCaptchaKey?key=" + response)
        .then((response) => {
          if (response.status == 200) {
            this.reCaptchaPassed = response.data.success;

            if (this.reCaptchaPassed && this.actionTriggered) {
              //dispatch user action
              switch (this.actionTriggered) {
                case actions.newCustomer:
                  this.newCustomer();
                  break;
                case actions.passwordReset:
                  this.togglePasswordReset();
                  break;
                case actions.registration:
                  this.toggleRegistration();
                  break;
                case actions.signin:
                  this.signin();
                  break;
              }
              this.actionTriggered = "";
            }
          } else this.reCaptchaPassed = false;
        })
        .catch((err) => {
          console.log("err", err);
          this.reCaptchaPassed = false;
        });
    },
    onCaptchaExpired(item) {
      this.reCaptchaPassed = false;
    },
    goToEbill(location) {
      if (location == "unsub") this.$router.push("/unsubscribe");
      else this.$router.push("/ebill");
    },
    //regAccDescriptionTooltip
    getAccDescriptionTooltip() {
      var parameter = {
        Lang: this.$i18n.locale,
        TextId: 55,
      };
      axios.post("/Utility/GetMessage", parameter).then((response) => {
        if (response.data.data.status == 0) {
          this.regAccDescriptionTooltip = response.data.settings.text;
        }
      });
    },
    //regCustomerAccountIdNoTooltip
    getCustomerAccountIdNoTooltip() {
      var parameter = {
        Lang: this.$i18n.locale,
        TextId: 58,
      };
      axios.post("/Utility/GetMessage", parameter).then((response) => {
        if (response.data.data.status == 0) {
          this.regCustomerAccountIdNoTooltip = response.data.settings.text;
        }
      });
    },
    // regCustomerMobileNoTooltip
    getCustomerMobileNoTooltip() {
      var parameter = {
        Lang: this.$i18n.locale,
        TextId: 59,
      };
      axios.post("/Utility/GetMessage", parameter).then((response) => {
        if (response.data.data.status == 0) {
          this.regCustomerMobileNoTooltip = response.data.settings.text;
        }
      });
    },
    getPrivacyLink() {
      var parameter = {
        Lang: this.$i18n.locale,
        TextId: 52,
      };
      axios.post("/Utility/GetMessage", parameter).then((response) => {
        if (response.data.data.status == 0) {
          this.privacyLinkUrl = response.data.settings.text; // 'https://www.google.com';
        }
      });
    },
    viewPrivacyPolicy() {
      if (this.enforceLicenceAgreement) this.showTermsDialog = this.bShowTerms;
      else {
        if (this.privacyLinkUrl) window.open(this.privacyLinkUrl, "_blank");
      }
    },
    setFocus() {
      var el;
      if (this.resetPassword || !this.registration)
        if (
          this.$refs.login.$el.children &&
          this.$refs.login.$el.children.length > 0 &&
          this.$refs.login.$el.children[0].children &&
          this.$refs.login.$el.children[0].children.length > 1
        )
          el = this.$refs.login.$el.children[0].children[1];
        else el = this.$refs.register.$el;
      Vue.nextTick(function () {
        if (el) el.focus();
      });
    },
    getTermsBox() {
      axios.post("/Utility/GetSettings").then((response) => {
        if (response.data.data.status == 0) {
          this.bShowTerms = response.data.value.isShowTermsAndConditions;
          this.termsAgreed =
            this.bShowTerms === false ? true : this.termsAgreed;
          this.ebillEnabeled = response.data.value.enableEBillRegistration;
          this.legalLabel = !response.data.value.isTermOfUse
            ? this.$t("login.PrivacyPolicy")
            : this.$t("login.TermsOfUse");
        }
      });
    },
    reCaptchaWarning(action) {
      //console.log("dss", action)
      this.actionTriggered = action;

      this.reCaptchaWarn = true;
      setTimeout(() => {
        this.reCaptchaWarn = false;
      }, 1200); //.3sec from css x 4 movement
    },
    toggleRegistration() {
      if (this.reCaptchaPassed == false) {
        this.reCaptchaWarning(actions.registration);
        return;
      }

      this.registration = !this.registration;
      if (!this.registration) this.sendPasswordCompleted = false;
      this.setFocus();
    },
    togglePasswordReset() {
      if (this.reCaptchaPassed == false) {
        this.reCaptchaWarning(actions.passwordReset);
        return;
      }

      this.resetPassword = !this.resetPassword;
      this.setFocus();
    },
    onEnterClick: function () {
      alert("Enter was pressed");
    },
    signin() {
      if (this.reCaptchaPassed == false) {
        this.reCaptchaWarning(actions.signin);
        return;
      }

      if (!this.loginEnabled) {
        this.$notify({
          duration: 10000,
          group: "app",
          text: this.$t("messages.MandatoryFields"),
          type: "warn",
        }); // title: '',
        return;
      }

      if (!this.acceptPrivacy) {
        if (this.bShowTerms) {
          this.$notify({
            duration: 10000,
            group: "app",
            text:
              this.legalLabel == "Privacy Policy"
                ? this.$t("login.AcceptPrivacyPolicy")
                : this.$t("login.AcceptTermsOfUse"),
            type: "warn",
          }); // title: '',
          return;
        }

        if (this.enforceLicenceAgreement && this.showLicenceAgreementButton) {
          this.showTermsDialog = this.bShowTerms;
          return;
        }
      }

      if (this.loginOtp === true && this.otpCodeSent === false) {
        this.sendOtpCode();
        return;
      }
      var parameter = {
        Email: this.email.email,
        Password: this.passwords.password,
        OtpCode: "",
        TrustedComputer: this.trustedComputer,
      };
      if (this.loginOtp === true && this.otpCodeSent === true) {
        parameter.OtpCode = this.otpCode;
      }
      this.$localStorage.set(
        "_trustedComputer",
        JSON.stringify(this.trustedComputer)
      );
      this.isInComm = true;
      this.$root.$emit("enable_disable_loader", true);
      axios
        .post("/account/Login", parameter)
        .then((response) => {
          this.isInComm = false;
          if (response.data.data.status == 0) {
            this.$localStorage.set("_login", this.email.email);
            this.$root.$emit("user_loggedin");
            this.$localStorage.set("_notification", "true");

            if (this.enforceLicenceAgreement)
              this.saveToLocal(
                "license_aggrement_hash",
                this.licenceAgreementHash
              );
          } else
            this.$notify({
              duration: 10000,
              group: "app",
              text: response.data.data.text,
              type: "warn",
            });
          this.$root.$emit("enable_disable_loader", false);
        })
        .catch((error) => {
          this.$notify({
            duration: 10000,
            group: "app",
            text: error.response.data.text,
            type: "warn",
          });
          this.$router.push("/login").catch(() => {}); //this.$router.push('/login');
          this.$root.$emit("enable_disable_loader", false);
        });
    },
    sendOtpCode() {
      this.isInComm = true;
      this.$root.$emit("enable_disable_loader", true);
      axios
        .post("/account/LoginWithOtpStage1", {
          Email: this.email.email,
          Password: this.passwords.password,
        })
        .then((response) => {
          this.isInComm = false;
          if (response.data.data.status == 0) {
            this.otpSent();
            this.otpCodeSent = true;
            this.$notify({
              duration: 10000,
              group: "app",
              text: this.$t("login.OtpCodeSentMessage"),
              type: "",
            });
          } else
            this.$notify({
              duration: 10000,
              group: "app",
              text: response.data.data.text,
              type: "warn",
            });
          this.$root.$emit("enable_disable_loader", false);
        })
        .catch((error) => {
          this.$notify({
            duration: 10000,
            group: "app",
            text: error.response.data.text,
            type: "warn",
          });
          this.$router.push("/login").catch(() => {}); //this.$router.push('/login');
          this.$root.$emit("enable_disable_loader", false);
        });
    },
    register() {
      if (!this.registerEnabled) {
        this.$notify({
          duration: 10000,
          group: "app",
          text: this.$t("messages.MandatoryFields"),
          type: "warn",
        }); // title: '',
        return;
      }

      if (this.passwords.password !== this.passwords.password2) {
        this.$notify({
          duration: 10000,
          group: "app",
          text: this.$t("newPassword.PassNoMatch"),
          type: "warn",
        });
        return;
      }

      this.isInComm = true;

      let parameter = {
        AccountName: this.accountName,
        Password: this.passwords.password,
        IdNo: this.id,
        MobileNo: this.mobileNo,
        SendOtpCode: true,
        RegistrationType: this.isEmailEntered ? 1 : 2,
      };

      if (this.isEmailEntered)
        parameter["Email"] = this.email.email.toLowerCase();
      else parameter["MobileNo"] = this.email.email;

      this.$root.$emit("enable_disable_loader", true);
      axios
        .post("/account/RegisterProfile", parameter)
        .then((response) => {
          this.isInComm = false;
          if (response.data.data.status == 0) {
            this.registrationCompleted = true;
          } else
            this.$notify({
              duration: 10000,
              group: "app",
              text: response.data.data.text,
              type: "warn",
            }); // title: '',
          this.$root.$emit("enable_disable_loader", false);
        })
        .catch((e) => {
          this.$router.push("/register");
          this.$root.$emit("enable_disable_loader", false);
        });
    },
    sendPassword() {
      this.isInComm = true;
      this.$root.$emit("enable_disable_loader", true);
      axios
        .post("/account/SendResetUserPassword", {
          Email: this.email.email,
          SendOtpCode: true,
        })
        .then((response) => {
          this.isInComm = false;
          this.$root.$emit("enable_disable_loader", false);
          if (response.data.data.status == 0) {
            this.sendPasswordCompleted = true;
            this.$router.push(
              "/account/resetPassword/" + this.email.email.toLowerCase()
            );
          } else
            this.$notify({
              duration: 10000,
              group: "app",
              text: response.data.data.text,
              type: "warn",
            }); // title: '',
        })
        .catch((e) => {
          this.$router.push("/register");
          this.$root.$emit("enable_disable_loader", false);
        });
    },
    getPortalWelcomeMessage() {
      axios
        .post("/Utility/GetPortalWelcomeMessage", { Value: this.$i18n.locale })
        .then((response) => {
          if (response.data.data.status == 0) {
            this.settings = response.data.settings;
          }
        });
    },
    getRegisterAccountDescription() {
      var parameter = {
        Lang: this.$i18n.locale,
        TextId: 3, //(this.portalProfileType == portalProfileDef.Customer.type) ? portalTextDef.CustomerAccountDescription.type : portalTextDef.EmployeeAccountDescription.type
      };
      axios.post("/Utility/GetMessage", parameter).then((response) => {
        if (response.data.data.status == 0) {
          this.regAccDescription = response.data.settings.text;
        }
      });
    },
    getAccountExampleImage() {
      axios.get("/Utility/GetAccountExampleImage").then((response) => {
        if (response.status === 200) {
          this.accountHelpImage = response.data;
        }
      });
    },
    getRegisterMessage() {
      axios
        .post("/Utility/GetMessage", { Lang: this.$i18n.locale, TextId: 39 })
        .then((response) => {
          if (response.data.data.status == 0) {
            this.regMessage = response.data.settings.text;
          }
        });
    },
    getRegisterIDNumber() {
      axios
        .post("/Utility/GetMessage", { Lang: this.$i18n.locale, TextId: 49 })
        .then((response) => {
          if (response.data.data.status == 0) {
            this.regAccIDNumber =
              response.data.settings.text &&
              response.data.settings.text.length > 0
                ? response.data.settings.text
                : this.$t("login.IDnumber");
          }
        });
    },
    getSettings() {
      axios.post("/Utility/GetSettings").then((response) => {
        if (response.data.data.status == 0) {
          //console.log("response", response.data.value);
          this.portalProfileType = response.data.value.portalProfileType;
          this.bSelectAccount = response.data.value.isSelectAccount;

          this.bValidateCustomerAccountEmail =
            response.data.value.isValidateCustomerAccountEmail;
          this.bValidateCustomerAccountEmail =
            this.portalProfileType === portalProfileDef.Customer.type
              ? this.bValidateCustomerAccountEmail
              : false;

          this.bValidateCustomerAccountIdNo =
            response.data.value.isValidateCustomerAccountIdNo;
          this.bValidateCustomerAccountIdNo =
            this.portalProfileType === portalProfileDef.Customer.type
              ? this.bValidateCustomerAccountIdNo
              : false;

          this.bValidateEmployeeAccountIdNo =
            response.data.value.isValidateEmployeeAccountIdNo;
          this.bValidateEmployeeAccountIdNo =
            this.portalProfileType === portalProfileDef.Employee.type
              ? this.bValidateEmployeeAccountIdNo
              : false;

          this.loginOtp = response.data.value.customerLoginWithOtp;

          this.bValidateCustomerAccountMobileNo =
            response.data.value.isValidateCustomerAccountMobileNo ||
            this.loginOtp;
          this.bValidateCustomerAccountMobileNo =
            this.portalProfileType === portalProfileDef.Customer.type
              ? this.bValidateCustomerAccountMobileNo
              : false;

          this.bStrongPassword = response.data.value.strongPassword;

          this.portalAuthenticationType =
            response.data.value.portalAuthenticationType;

          this.newCustomerEvaluationApplication =
            response.data.value.newCustomerEvaluationApplication;
          this.newCustomerApplication =
            response.data.value.newCustomerApplication;

          this.reCaptchaApiKey = response.data.value.reCaptchaApiKey;

          if (this.reCaptchaApiKey == null || this.reCaptchaApiKey == "") {
            this.reCaptchaEnabled = false;
            this.reCaptchaPassed = true;
          } else {
            this.reCaptchaEnabled = true;
            this.reCaptchaPassed = false;
          }

          this.getRegisterAccountDescription();
          this.getRegisterMessage();
        }
      });
    },
    getButtonsText() {
      //CustomerPortalRegisterAccountButtonText - 77
      //CustomerPortalForgotPasswordButtonText - 78
      //CustomerPortalNewCustomerEvalButtonText - 79

      let param = {
        TextId: 77,
        Lang: this.getLanguage(),
      };

      axios
        .post("/Utility/GetMessage", param)
        .then((response) => {
          //console.log("resp", response)
          if (response.data.data.status == 0)
            this.registerAccountButtonText =
              response.data.settings.text != null &&
              response.data.settings.text != ""
                ? response.data.settings.text
                : "";
        })
        .catch();

      param.TextId = 78;
      axios
        .post("/Utility/GetMessage", param)
        .then((response) => {
          //console.log("resp", response)
          if (response.data.data.status == 0) {
            let temp =
              response.data.settings.text != null &&
              response.data.settings.text != ""
                ? response.data.settings.text
                : "";
            this.forgotPasswordButtonText = temp
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "");
          }
        })
        .catch();

      param.TextId = 79;
      axios
        .post("/Utility/GetMessage", param)
        .then((response) => {
          //console.log("resp", response)
          if (response.data.data.status == 0) {
            let temp =
              response.data.settings.text != null &&
              response.data.settings.text != ""
                ? response.data.settings.text
                : "";
            this.newCustomerEvalButtonText = temp
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "");
          }
        })
        .catch();
    },
    getLanguage() {
      let lang = this.$localStorage.get("_lang");
      return lang != null && lang != "" ? lang : "en";
    },
    newCustomer() {
      if (this.reCaptchaPassed == false) {
        this.reCaptchaWarning(actions.newCustomer);
        return;
      }

      if (this.newCustomerApplication)
        //general app for new customer
        this.$router.push("/newCustomer");
      else if (this.newCustomerEvaluationApplication)
        //the one for bioland
        this.$router.push("/customerEvaluation");
    },
    confirmOTP() {
      this.otpCodeConfirm;

      if (!this.otpCodeConfirm == null) {
        this.$notify({
          duration: 10000,
          group: "app",
          text: this.activateAccountResultErrors[1],
          type: "warn",
        });
      } else {
        var parameter = { Value: this.otpCodeConfirm };
        axios
          .post("/account/ActivateAccount", parameter)
          .then((response) => {
            if (response.data.data.status == 0) {
              this.$notify({
                duration: 10000,
                group: "app",
                text: "Account Created, you will be redirected to login page in a moment",
                type: "success",
              });
              this.toggleRegistration();
            } else {
              this.$notify({
                duration: 10000,
                group: "app",
                text: response.data.data.text,
                type: "error",
              });
            }
          })
          .catch((e) => {
            this.$notify({
              duration: 10000,
              group: "app",
              text: e,
              type: "error",
            });
          });
      }
    },

    getLicenceAgreement() {
      axios
        .post("/Utility/GetPortalLicenceAgreement", {
          Value: this.getLanguage(),
        })
        .then((response) => {
          //console.log("GetPortalLicenceAgreement", response.data.settings.text)
          if (response.data.data.status != 0 || response.status != 200) {
            this.licenceAgreementText = null;
            return;
          }

          this.licenceAgreementText = response.data.settings.text;
          if (this.licenceAgreementText && this.licenceAgreementText.length > 0)
            this.removeFromLocal("legal_accepted");
        })
        .catch((err) => {
          this.licenceAgreementText = null;
          console.log("err:", err);
        })
        .finally(() => this.getLicenceAgreementHash());
    },
    getLicenceAgreementHash() {
      if (
        !this.enforceLicenceAgreement ||
        this.enforceLicenceAgreement.length == 0
      ) {
        this.acceptPrivacyPolicy(
          this.getFromLocal("legal_accepted") ?? false,
          false
        );
        return;
      }

      axios
        .post("/Utility/GetPortalLicenceAgreementHash", {
          Value: this.getLanguage(),
        })
        .then(async (response) => {
          //console.log("GetPortalLicenceAgreement Hash", response.data)
          if (response.status != 200) {
            this.licenceAgreementHash = null;
            this.acceptPrivacyPolicy(
              this.getFromLocal("legal_accepted") ?? false,
              true
            );
            return;
          }

          this.licenceAgreementHash = response.data;

          let hash = await this.getFromLocal("license_aggrement_hash");

          if (this.licenceAgreementHash == hash) {
            this.showLicenceAgreementButton = false;
            this.acceptPrivacy = true;
          } else {
            this.showLicenceAgreementButton = true;
            this.acceptPrivacyPolicy(false, true);
          }
        })
        .catch((err) => {
          this.licenceAgreementHash = null;
          this.showLicenceAgreementButton = true;
          this.acceptPrivacyPolicy(false, true);
        });
    },
    acceptPrivacyPolicy(policy = false, showDialog = false) {
      this.acceptPrivacy = policy;
      this.termsAgreed = policy;
      this.showTermsDialog = this.bShowTerms ? showDialog : false;
      if (policy) this.saveToLocal("legal_accepted", policy);
      this.$forceUpdate();
    },
    viewTandC() {
      this.showTermsDialog = true;
    },
    legalAccept(val) {
      this.saveToLocal("legal_accepted", val);
    },
  },
};
